import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import * as IBooks from '../../../../interfaces/merchants/resources/books';
import * as IInputs from '../../../../interfaces/merchants/resources/books/inputs';

import scrollToTop from '../../../hoc/scrollToTop';

import BooksSubmitButton from '../../../../components/books/common/buttons/BooksSubmitButton';
import BooksErrorMessage from '../../../../components/books/model1/forms/BooksErrorMessage';

import css from './InputCompletionFailed.module.scss';

interface ElementProps {
  merchantResource: IBooks.MerchantResource;
  settings: IBooks.SettingCompletion;
  backToLabel: string;
  backToModifyPage: () => void;
}

interface StateProps {
  inputs: IInputs.State;
}

type Props = ElementProps & StateProps & InjectedIntlProps;

const InputCompletionFailed: React.SFC<Props> = (props: Props) => {
  const { settings, backToLabel, backToModifyPage, intl } = props;

  return (
    <div className={css.InputCompletionFailed}>
      {settings.entireError && (
        <BooksErrorMessage
          errorType={settings.entireError}
          className={css.InputCompletionFailed__ErrorMessage}
        />
      )}
      <BooksSubmitButton
        onClick={backToModifyPage}
        value={intl.formatMessage({
          id: backToLabel,
        })}
      >
        {intl.formatMessage({
          id: backToLabel,
        })}
      </BooksSubmitButton>
    </div>
  );
};

const mapStateProps = ({
  merchantsResourcesBooksInputs,
}: {
  merchantsResourcesBooksInputs: IInputs.State;
}): StateProps => ({
  inputs: merchantsResourcesBooksInputs,
});

export default connect(mapStateProps)(
  injectIntl(scrollToTop(InputCompletionFailed)),
);
